import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';

import { SharedService } from '../_services/shared.service';
const NOT_AUTHORIZED = 401;
const FORBIDDEN = 403;
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private _router: Router,
        private _sharedService: SharedService
    ) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser)
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        return next.handle(request).catch((err: any, caught) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === NOT_AUTHORIZED || err.status === FORBIDDEN) {
                    if (this._router.url != '/' && !this._router.url.includes('/login')) {
                        let state = this._router.routerState.snapshot;
                        setTimeout(() => {
                            this._sharedService.emitUnauthorized();
                        }, 500);
                        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    }
                }
                return Observable.throw(err);
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_interceptors/token.interceptor.ts